<template>
  <v-container class="pa-0">
    <v-form ref="form">
      <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
        <page-header-title :title="page_title"></page-header-title>

        <v-spacer></v-spacer>

        <action-button type="cancel" @click="$emit('return_modal_cancel_form')" v-if="modal == true" />
        <action-button type="back" @click="$router.go(-1)" v-if="modal != true" />
        <action-button type="save" @click="save" />

        <action-button type="delete" @click="del(address.id)" v-if="address.id && $can('address-delete') && modal != true" />
      </v-app-bar>

      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="address.name"
                  v-model="address.name"
                  v-validate="'max:50'"
                  :label="$t('addresses.name')"
                  :error-messages="errors.collect('address.name')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="address.street"
                  v-model="address.street"
                  class="required-field"
                  v-validate="'required|max:50'"
                  :label="$t('addresses.street')"
                  :error-messages="errors.collect('address.street')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg1 md4 sm6 xs12>
                <v-text-field
                  name="address.zip"
                  v-model="address.zip"
                  class="required-field"
                  v-validate="'required|max:10'"
                  :label="$t('addresses.zip')"
                  :error-messages="errors.collect('address.zip')"
                  @blur="zipCodeChange"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg2 md4 sm6 xs12>
                <v-text-field
                  name="address.city"
                  v-model="address.city"
                  class="required-field"
                  v-validate="'required|max:50'"
                  :label="$t('addresses.city')"
                  :error-messages="errors.collect('address.city')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg2 md4 sm6 xs12>
                <v-text-field
                  name="address.state"
                  v-model="address.state"
                  v-validate="'max:50'"
                  :label="$t('addresses.state')"
                  :error-messages="errors.collect('address.state')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-autocomplete
                  name="address.country"
                  v-model="address.country"
                  class="required-field"
                  v-validate="'required'"
                  :items="this.$dd_countries()"
                  item-text="text"
                  item-value="key"
                  :label="$t('addresses.country')"
                  autocomplete="new-password"
                  :error-messages="errors.collect('address.country')"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-select
                  name="address.status"
                  v-model="address.status"
                  class="required-field"
                  v-validate="'required'"
                  item-text="text"
                  item-value="key"
                  :items="this.$dd_address_status()"
                  :label="$t('addresses.status')"
                  :error-messages="errors.collect('address.status')"
                  clearable
                ></v-select>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "AddressTypesForm",

  props: ["id", "modal"],

  data() {
    return {
      page_title: "",
      predata: {},
      address: {},
      dictionary: {
        attributes: {
          "address.name": this.$t("addresses.name"),
          "address.street": this.$t("addresses.street"),
          "address.city": this.$t("addresses.city"),
          "address.state": this.$t("addresses.state"),
          "address.zip": this.$t("addresses.zip"),
          "address.country": this.$t("addresses.country"),
          "address.status": this.$t("addresses.status")
        }
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    this.$validator.validateAll().then(() => {
      this.$leaveFormConfirmation(next, this.address, this.predata, this.save, this.isFormValid)
    })
  },

  computed: {
    isFormValid() {
      return !Object.keys(this.fields).some((key) => this.fields[key].invalid)
    }
  },

  mounted() {
    this.$validator.localize(this.$getSetting("locale"), this.dictionary)
  },

  created() {
    // Get Address
    if (!this.id) {
      this.page_title = this.$t("addresses.new_address")
      this.address = {
        country: this.$getDefaultDropdown(this.$dd_countries()),
        status: this.$getDefaultDropdown(this.$dd_address_status())
      }

      // JSON stringify and parse to remove variable reactiveness
      this.predata = JSON.parse(JSON.stringify(this.address))
    } else {
      this.title = this.$t("addresses.update_title")

      axios
        .get(this.API_URL + "address/" + this.id)
        .then((res) => {
          this.address = res.data.data

          // JSON stringify and parse to remove variable reactiveness
          this.predata = JSON.parse(JSON.stringify(this.address))

          this.page_title = this.$t("addresses.edit_address", {
            name: this.address.title
          })
        })
        .catch((err) => console.log(err))
    }
  },

  methods: {
    save() {
      this.$validator.validate()

      this.$validator
        .validateAll()
        .then(() => {
          if (this.isFormValid) {
            let vm = this
            let user = this.$store.getters["auth/user"]

            if (!this.address.id) {
              // Create
              axios
                .post(this.API_URL + "address", {
                  name: this.address.name,
                  street: this.address.street,
                  city: this.address.city,
                  state: this.address.state,
                  zip: this.address.zip,
                  country: this.address.country,
                  status: this.address.status,
                  created_by: user.id
                })
                .then((res) => {
                  if (typeof res.data.errors !== "undefined") {
                  } else {
                    if (res.data.data.id) {
                      vm.address = res.data.data
                      vm.predata = JSON.parse(JSON.stringify(vm.address))

                      vm.$awn.success(vm.$t("global.create_success"))

                      if (vm.modal) {
                        vm.$emit("return_modal_form", {
                          module: "addresses",
                          mode: "add",
                          data: res.data.data
                        })
                      } else {
                        vm.page_title = this.$t("addresses.edit_address", {
                          name: vm.address.title
                        })
                        vm.$router.replace(this.BACKEND_URL + `/addresses/edit/${vm.address.id}`).catch(() => {})
                      }
                    }
                  }
                })
                .catch((err) => console.log(err))
            } else {
              // Update
              axios
                .put(this.API_URL + "address", {
                  id: this.address.id,
                  street: this.address.street,
                  name: this.address.name,
                  city: this.address.city,
                  state: this.address.state,
                  zip: this.address.zip,
                  country: this.address.country,
                  status: this.address.status
                })
                .then((res) => {
                  vm.address = res.data.data
                  vm.predata = JSON.parse(JSON.stringify(vm.address))

                  vm.$awn.success(vm.$t("global.update_success"))

                  if (vm.modal) {
                    vm.$emit("return_modal_form", {
                      module: "addresses",
                      mode: "edit",
                      data: res.data.data
                    })
                  }
                })
                .catch((err) => console.log(err))
            }
          } else {
            this.$awn.alert(this.$t("global.form_not_valid"))
          }
        })
        .catch(() => {})
    },
    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "address/" + id)
            .then((res) => {
              vm.$router.push(this.BACKEND_URL + "/addresses")
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },

    zipCodeChange() {
      this.$getCity(this.address.zip, this.address.country)
        .then((res) => {
          if (res.status == 200) {
            this.$set(this.address, "city", res.data.postalCode.city)
          }
        })
        .catch((error) => {
          this.$set(this.address, "city", null)
        })
    }
  }
}
</script>

<style scoped></style>
